import styled from 'styled-components';

import { Table } from 'reactstrap';
import { Input } from 'takeat-design-system-ui-kit';

export const Card = styled.div`
  background: #f6f6f6;
  border-radius: 10px;
  overflow: none;
  margin-top: 20px;
`;

export const Map = styled.div`
  width: 100%;
  height: 600px;
  border-radius: 4px;
`;

export const AddressesTable = styled(Table)`
  width: 100%;
  min-width: 360px;
  margin: 0px;
  margin-top: 8px;
  padding: 0px;
  background-color: #f6f6f6;
  thead {
    th {
      background-color: #f6f6f6;
    }
    text-align: left;

    tr > th {
      text-transform: none;
    }
  }

  tbody {
    background-color: #f6f6f6;
    td {
      background-color: #f6f6f6;
    }
    tr:first-child td {
      padding: 5px !important;
    }

    tr:not(:first-child) td {
      padding: 5px 5px !important;
    }
  }
`;

export const PlusButton = styled.button`
  height: 40px;
  width: 40px;
  padding: 0 10px;
  border-radius: 8px;
  border: none;
  background-color: #0ccab4;
  svg {
    color: #fff;
  }
  &:disabled {
    pointer-events: none;
    cursor: not-allowed;
    background-color: transparent;
    border: 1px solid #0ccab4;
    svg {
      color: #0ccab4;
    }
  }
`;

export const InputStyled = styled(Input)`
  background-color: #fff;
  border-radius: 8px;
`;

export const TaxTitle = styled.h3`
  font-family: Poppins;
  font-weight: 600;
  font-style: SemiBold;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.15px;
  color: #222;
`;
